import { Shield, Award, Clock, Star } from 'lucide-react';
import { motion } from 'motion/react';

const badges = [
  { icon: Shield, text: 'Licensed & Insured' },
  { icon: Award, text: '1-Year Warranty' },
  { icon: Clock, text: 'Fast Turnaround' },
  { icon: Star, text: '5-Star Rated' },
];

export function TrustBadges() {
  return (
    <section className="py-12 bg-white border-y border-border">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-8 md:gap-12">
          {badges.map((badge, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex flex-col items-center gap-2"
            >
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                <badge.icon className="w-6 h-6 text-primary" />
              </div>
              <span className="text-sm text-center">{badge.text}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
